<template>
  <MainHeader />
  <MainSidebar />
  <div
    class="main-content pos-page-content bg_gray d-flex flex-column transition overflow-hidden"
  >
    <div class="pos-content d-flex flex-wrap justify-content-between">
      <PosLeftContent />
      <PosRightContent />
    </div>
    <EditContent />

    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>

  <div
    class="delete-popup offcanvas offcanvas-end border-0"
    tabindex="-1"
    id="deletePopup"
  >
    <div class="offcanvas-body p-0">
      <div class="delete-success">
        <img src="../../assets/img/icons/tick-circle.svg" alt="Image" />
        <span class="text-white fw-medium">
          Your product is deleted from the list.
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted } from "vue";

import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import PosLeftContent from "../../components/Sales/Pos/PosLeftContent.vue";
import PosRightContent from "../../components/Sales/Pos/PosRightContent.vue";
import EditContent from "../../components/Sales/Pos/EditContent.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";

const SIDEBAR_STATE_EVENT = "app-sidebar-state-change";
const SIDEBAR_COMPACT_BREAKPOINT = 1199;

export default defineComponent({
  name: "PosPage",
  components: {
    MainHeader,
    MainSidebar,
    PosLeftContent,
    PosRightContent,
    EditContent,
    MainFooter,
  },
  setup() {
    let lastCompactState = false;

    const broadcastSidebarState = (minimized: boolean) => {
      window.dispatchEvent(
        new CustomEvent(SIDEBAR_STATE_EVENT, {
          detail: { minimized },
        })
      );
    };

    const setSidebarMinimized = (minimized: boolean, persist = false) => {
      document.body.classList.toggle("minimized", minimized);

      if (persist) {
        localStorage.setItem("minimized", minimized.toString());
      }

      broadcastSidebarState(minimized);
    };

    const resetSidebarForViewport = () => {
      const shouldHideSidebar = window.innerWidth > SIDEBAR_COMPACT_BREAKPOINT;
      setSidebarMinimized(shouldHideSidebar);
    };

    const handleResize = () => {
      const isCompact = window.innerWidth <= SIDEBAR_COMPACT_BREAKPOINT;

      if (isCompact !== lastCompactState) {
        lastCompactState = isCompact;
        resetSidebarForViewport();
      }
    };

    onMounted(() => {
      lastCompactState = window.innerWidth <= SIDEBAR_COMPACT_BREAKPOINT;
      resetSidebarForViewport();
      window.addEventListener("resize", handleResize, { passive: true });
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
      setSidebarMinimized(false);
    });

    return {};
  }
});
</script>

<style scoped>
.pos-page-content {
  padding-top: 104px !important;
}

@media only screen and (max-width: 1199px) {
  .pos-page-content {
    padding-top: 112px !important;
  }
}

@media only screen and (max-width: 767px) {
  .pos-page-content {
    padding-top: 136px !important;
  }
}
</style>
